import React from 'react'
import Grid from '@mui/material/Grid'
import Skeleton from '@mui/material/Skeleton'
import Box from '@mui/material/Box'
import styled from 'styled-components'

const StyledSkeleton = styled(Skeleton)`
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;
`

const CardSkeleton = ({ count }: { count: number }) => {
  return (
    <Box width="100%" data-testid="ta-card-skeleton">
      {[...Array(count)].map((_, index) => (
        <Grid item xs={12} md={12} lg={8} key={index}>
          <StyledSkeleton variant="rectangular" height={225} />
        </Grid>
      ))}
    </Box>
  )
}

export { CardSkeleton }
